import * as React from "react";
const SvgFiBrandsJcb = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M3.033 3.01C1.452 3.01.007 4.379.007 5.914v7.515c.289.175 1.682.604 2.243.642 1.228.083 1.988-.306 2.106-1.288l-.005-3.648h2.716V12.7c-.143 2.042-2.009 2.457-4.85 2.32-.735-.036-1.734-.218-2.212-.337L.004 20.99H4.73c1.29 0 2.969-1.157 2.969-2.916V3.009zM0 13.426v1.256h.005V13.43zM11.704 3.01c-1.581 0-3.026 1.369-3.026 2.904V9.89c.948-.711 2.477-1.06 4.423-.916 1.107.082 1.926.23 2.373.357v1.262c-.492-.236-1.463-.587-2.273-.643-1.835-.127-2.798.699-2.798 2.033 0 1.2.744 2.229 2.79 2.092.676-.045 1.799-.423 2.277-.641l.005 1.224c-.411.125-1.69.392-2.896.4-1.813.015-3.093-.354-3.9-.954l-.002 6.887h4.726c1.29 0 2.969-1.157 2.969-2.916V3.01zM20.672 12.365c-.518.005-1.647-.005-1.851 0l-.003 1.589 1.85.006c.36 0 .813-.296.813-.811 0-.456-.39-.787-.81-.784M21.256 10.77a.733.733 0 0 0-.736-.754c-.534.012-1.495-.013-1.705.005l-.007 1.446 1.75.012c.291-.005.698-.261.698-.708"
    />
    <path
      fill="#151A2D"
      d="M20.334 3.01c-1.58 0-3.026 1.369-3.026 2.904V9.11h4.493c.894 0 1.947.367 1.947 1.41 0 .56-.31 1.194-1.43 1.4v.024c.654 0 1.786.367 1.786 1.474 0 1.143-1.224 1.46-1.879 1.46l-4.919.005v6.108h4.725c1.29 0 2.969-1.157 2.969-2.916V3.01z"
    />
  </svg>
);
export default SvgFiBrandsJcb;
